import createMentionPlugin, { defaultTheme } from '@draft-js-plugins/mention';
import { useMemo } from 'react';
export function useEditorMentions(originalPlugins, enabled) {
    const result = useMemo(() => {
        const conditionalMentionPlugin = [];
        const mentionPlugin = createMentionPlugin({
            entityMutability: 'IMMUTABLE',
            mentionPrefix: '@',
            supportWhitespace: true,
            theme: Object.assign(Object.assign({}, defaultTheme), { mention: 'mention' })
        });
        if (enabled) {
            conditionalMentionPlugin.push(mentionPlugin);
        }
        return {
            MentionSuggestions: mentionPlugin.MentionSuggestions,
            plugins: [...originalPlugins, ...conditionalMentionPlugin]
        };
    }, [enabled, originalPlugins]);
    return result;
}
